import React from 'react';
import { Col, Container, Row } from 'reactstrap';
import MensagemForm from './components/MensagemForm';

const Mensagem = (props) => {
  return (
    <Container>
      <Row>
        <Col md={12}>
          <h3 className="page-title">Mensagem</h3>
          <h3 className="page-subhead subhead">
            Adicione uma nova mensagem ou altere suas informações cadastrais
          </h3>
        </Col>
      </Row>
      <Row>
        <MensagemForm isHorizontal={false} isAboveError props={props} />
      </Row>
    </Container>
  );
};

export default Mensagem;
